import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {handleErrorResponse} from "../utils/util";
import { USER_ROLE } from "../constants/index";
import i18n from 'i18next';
import { resetAppState } from "../store/common";

const initialState = {
  isShowReferralPopup: false,
};

export const friendInvitationSlice = createSlice({
  name: 'friendInvitation',
  initialState,
  reducers: {
    setShowReferralPopup: (state, action) => {
      state.isShowReferralPopup = action.payload;
    },
  },
});

export const {
  setShowReferralPopup,
} = friendInvitationSlice.actions;

export default friendInvitationSlice.reducer;